import { queryKeyFactory } from "@l2r-front/l2r-query"

export const SURVEYS_ROOT_QUERY_KEY = "surveys"

export const surveysQueryKeys = queryKeyFactory(SURVEYS_ROOT_QUERY_KEY, {})
